declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function trackEvent(name: string, params?: Record<string, unknown>) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}

export function trackPageView(path: string, title?: string) {
  trackEvent('page_view', {
    page_location: window.location.origin + path,
    page_title: title ?? document.title,
  });
}
